import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export default function LazyImage({ src, alt, className, style, ...props }) {
  if (!src) {
    return (
      <div 
        className={`bg-gray-700 flex items-center justify-center ${className || ''}`}
        style={style}
      >
        <span className="text-gray-500 text-xs">No image</span>
      </div>
    );
  }

  return (
    <LazyLoadImage
      src={src}
      alt={alt || ''}
      effect="blur"
      className={className}
      style={style}
      {...props}
    />
  );
}
